import React from "react";
import { motion } from "framer-motion";
import { Layers, UserCheck, LifeBuoy, ScrollText, Cpu } from "lucide-react";
import { useI18n } from "../i18n";

const ICONS = [Layers, UserCheck, LifeBuoy, ScrollText, Cpu];

export default function ValueProps() {
    const { dict, t } = useI18n();
    const pillars = dict.value.pillars;

    return (
        <section id="value" data-testid="value-section" className="section-pad relative scroll-mt-24">
            <div className="container-page">
                <div className="mb-14 max-w-3xl">
                    <span className="eyebrow">{t("value.eyebrow")}</span>
                    <h2
                        data-testid="value-title"
                        className="mt-5 text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tighter whitespace-pre-line"
                    >
                        {t("value.title")}
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-l border-white/[0.06]">
                    {pillars.map((p, idx) => {
                        const Icon = ICONS[idx % ICONS.length];
                        return (
                            <motion.div
                                key={p.title}
                                data-testid={`value-pillar-${idx}`}
                                initial={{ opacity: 0, y: 16 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-80px" }}
                                transition={{ duration: 0.5, delay: idx * 0.05 }}
                                className="relative border-r border-b border-white/[0.06] p-8 md:p-10 group"
                            >
                                <span className="absolute top-6 right-6 text-xs font-mono text-white/25">
                                    0{idx + 1}
                                </span>
                                <div className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-brand/10 text-brand-glow border border-brand/20">
                                    <Icon className="h-5 w-5" />
                                </div>
                                <h3 className="mt-5 text-xl md:text-2xl font-semibold tracking-tight">
                                    {p.title}
                                </h3>
                                <p className="mt-3 text-sm text-white/55 leading-relaxed">{p.desc}</p>
                                <span className="absolute left-0 bottom-0 h-px w-0 bg-gradient-to-r from-brand to-brand-glow group-hover:w-full transition-all duration-700" />
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
